module.exports = __webpack_public_path__ + "img/angel-minuscules.8bd8047b.jpg";